import { useNavigate } from "react-router-dom";
import Catalog from "@/components/Catalog";

export default function CatalogPage() {
  const navigate = useNavigate();
  return (
    <div className="pt-16">
      <Catalog onRequestQuote={(category) => navigate("/enquiry", { state: { product: category } })} />
    </div>
  );
}
